import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, CheckCircle2, AlertCircle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatDeShort } from "@/lib/date";

const eur = (v) => Number(v || 0).toLocaleString("de-DE", { style: "currency", currency: "EUR" });

export default function WbDatevPanel({ participantId }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/wb-datev/${participantId}`).then((r) => setD(r.data)).catch(() => setD(false));
  useEffect(() => { load(); }, [participantId]); // eslint-disable-line
  if (!d) return null;
  const send = async () => {
    if (!window.confirm("Unterschriebenen Vertrag jetzt an DATEV (Ausgangsrechnungen) senden?")) return;
    setBusy(true);
    try { await api.post(`/wb-datev/${participantId}/send`); toast.success("Vertrag an DATEV übertragen"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  const sent = d.datev_status === "sent";
  return (
    <div className="border border-slate-200 bg-white" data-testid="wb-datev-panel">
      <div className="px-5 py-4 flex items-start justify-between gap-4 flex-wrap border-b border-slate-100">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500">Abrechnung</div>
          <div className="font-heading text-xl font-light tracking-tighter text-slate-900">Abschlagsplan</div>
          <div className="text-xs mt-1 text-slate-500" data-testid="wb-datev-status">Bezahlte Abschläge bucht die Buchhaltung unter Abrechnung → Abschläge. Dabei geht automatisch eine Rechnung an DATEV.</div>
        </div>
        <div className="text-right">
          <div className="font-heading text-2xl font-light tracking-tighter text-slate-900" data-testid="wb-datev-total">{eur(d.total)}</div>
          <div className="text-[11px] text-slate-500">Gesamtkosten laut Vertrag</div>
          {false && (
            <button onClick={send} disabled={busy} className="mt-2 px-3 py-1.5 text-xs border border-slate-300 hover:bg-slate-100 disabled:opacity-50 inline-flex items-center gap-1.5" data-testid="wb-datev-send-btn">
              <Send size={12} /> {busy ? "Sendet…" : sent ? "Erneut an DATEV senden" : "An DATEV senden"}
            </button>
          )}
        </div>
      </div>
      <div className="p-5" data-testid="wb-installments">
        {d.installments.length === 0 ? <div className="text-sm text-slate-500">Abschlagsplan erscheint, sobald Start, Ende und Modulpreise hinterlegt sind.</div> : (
          <table className="w-full text-sm">
            <thead><tr className="text-[10px] uppercase tracking-overline text-slate-500 text-left"><th className="py-1">Abschlag</th><th>Fällig am</th><th className="text-right">Betrag</th></tr></thead>
            <tbody>{d.installments.map((i) => (
              <tr key={i.nr} className="border-t border-slate-100" data-testid={`wb-installment-${i.nr}`}>
                <td className="py-2">{i.nr}. Abschlag</td><td className="font-mono text-xs">{formatDeShort(i.date)}</td><td className="text-right font-mono">{eur(i.amount)}</td>
              </tr>))}
            </tbody>
          </table>
        )}
        <p className="text-[11px] text-slate-400 mt-3">Der Leistungsträger erhält keine Rechnung. Pro eingegangenem Abschlag entsteht eine Rechnung nur für DATEV (Ausgangsrechnungen).</p>
      </div>
    </div>
  );
}
